<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:p-6 lg:p-8">
    <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-3xl mb-8">
      <h2 class="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800">Submit Your Order</h2>

      <form @submit.prevent="submitOrder" class="space-y-4">
        <div v-for="(orderItem, index) in orderItems" :key="index" class="p-4 border rounded-lg shadow-sm bg-gray-50 space-y-2">
          <select v-model="orderItem.itemId"
                  class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-blue-500">
            <option v-for="item in items" :key="item.id" :value="item.id">
              {{ item.name }} - ${{ item.price.toFixed(2) }}
            </option>
          </select>
          <input type="number" v-model="orderItem.quantity"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-blue-500"
                 placeholder="Quantity"
                 min="1"
                 required />
        </div>

        <button @click="addItem"
                class="bg-green-500 text-white p-2 sm:p-3 mt-2 sm:mt-0 rounded-lg hover:bg-green-600 w-full sm:w-auto">
          Add Another Item
        </button>

        <button type="submit"
                class="bg-blue-500 text-white p-2 sm:p-3 mt-4 sm:mt-6 rounded-lg hover:bg-blue-600 w-full sm:w-auto">
          Submit Order
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapActions} from 'vuex';

export default {
  data() {
    return {
      items: [],
      orderItems: [
        {
          itemId: '',
          quantity: 1,
        },
      ],
    };
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    ...mapActions(['submitOrder']),
    fetchItems() {
      axios.get('http://localhost:5000/api/items')
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.error('Error fetching items:', error);
        });
    },
    addItem() {
      this.orderItems.push({
        itemId: '',
        quantity: 1,
      });
    }
  },
};
</script>
